import React from 'react';
import { ReactComponent as WaterIcon } from '../../Shared/svgs/water-ef-magenta.svg';
import { ReactComponent as WasteIcon } from '../../Shared/svgs/waste-ef-magenta.svg';
import { ReactComponent as ConnectivityIcon } from '../../Shared/svgs/connectivity-ef-magenta.svg';

const ICONS = {
    Water: WaterIcon,
    Waste: WasteIcon,
    Connectivity: ConnectivityIcon,
};

export default function UtilitiesOverview({ utilities, billingBalance }) {
    if (!utilities?.length) return null;

    return (
        <section className="utilities-overview-card" id="utilities-overview">
            {utilities.map((utility) => {
                const Icon = ICONS[utility.utilityType] ?? WaterIcon;
                const displayBalance = utility.utilityType === 'Water'
                    ? (billingBalance ?? utility.accountBalance)
                    : utility.accountBalance;

                return (
                    <div
                        className="utility-row"
                        key={utility.accountNumber}
                        id={`row-${utility.utilityType.toLowerCase()}-${utility.accountNumber}`}
                    >
                        <div className="utility-col account-cell">
                            <p className="utility-label">Account</p>
                            <div className="utility-account">
                                <Icon className="utility-icon" />
                                <strong>{utility.accountNumber}</strong>
                            </div>
                        </div>

                        <div className="utility-col">
                            <p className="utility-label">No. of locations</p>
                            <strong>{utility.numberOfLocations ?? '—'}</strong>
                        </div>

                        <div className="utility-col">
                            <p className="utility-label">
                                {utility.utilityType === 'Waste' ? 'No. of waste services' : 'No. of meters'}
                            </p>
                            <strong>{utility.numberOfMetersOrServices ?? '—'}</strong>
                        </div>

                        <div className="utility-col">
                            <p className="utility-label">Account balance</p>
                            <strong className={displayBalance < 0 ? 'is-credit' : ''}>
                                {displayBalance == null ? '—' : `£${displayBalance.toFixed(2)}`}
                            </strong>
                        </div>
                    </div>
                );
            })}
        </section>
    );
}
